<script>
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

import {
  userMethods,
  configComputed,
  userComputed,
  configMethods,
} from "@/state/helpers";
import { mixin } from "../../helpers/Vue-Mixin";
import { filter } from "../../helpers/Vue-Filter";
import Swal from "sweetalert2";
import Loader from "../../components/widgets/loader.vue";
import api from "@/api/";
import EditProfileUser from "@/components/widgets/edit-profile-user.vue";
import moment from 'moment';
import "vue2-datepicker/locale/ja";
import "vue2-datepicker/locale/en";
import Pagination from "../../components/widgets/pagination.vue";
import { getProfile } from "../../helpers/Auth";

const PageHeader = () =>
  import(/* webpackChunkName: "PageHeader" */ "@/components/page-header");
const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "../../router/layouts/main.vue");

export default {
  /* eslint-disable no-console */
  mixins: [mixin],

  filters: {
    ...filter,
  },

  page: {
    title: "会員一覧",
    meta: [{ name: "description", content: appConfig.description }],
  },

  // eslint-disable-next-line vue/no-unused-components
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Multiselect,
    Loader,
    EditProfileUser,
    Pagination
  },

  watch: {
    gPagination: {
      handler(value) {
        this.paginationPages = value.last_page;
      },
    },
  },

  data() {
    return {
      items: [
        {
          text: "会員一覧",
          href: "/admin/customers",
          active: true,
        },
      ],
      search: {},
      loading: false,
      paginationPages: 5,
      page: 1,
      dataInsert: {},
      dataUpdate: {},
      sortBy: "age",
      sortDesc: false,
      excelIds: [],
      keySort: "created_at",
      typeSort: 0,
      types: ["desc", "asc"],

      isAll: false,
      ignoreIds: [],
      role: "user",
      is_plus: [
        { label: '全て', value: '' },
        { label: 'くるあ', value: 1 },
        { label: 'くるあプラス', value: 2 }
      ],
      facilityNames: [],
      isFilterOpen: false,
      showModalEditProfileUser: false,
      dataEdit: [],
      lastLoadedTime: null,
      profile: getProfile(),
    };
  },

  created() {
    try {
      this.loading = true;
      this.getACountUser(this.role);
      this.getConfig();
      this.fetch({
        role: this.role
      }).then((e) => {
        if (e.status === 200) {
          this.loading = false;
        }
      });
      this.listFacility();
    } catch (error) {
      console.log(error);
    }
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');
    this.$store.dispatch('saveTheme', this.profile.role?.name === 'admin' ? 'admin' : this.profile.facility?.type === 2 ? 'plus' : 'normal');
  },

  computed: {
    ...userComputed,
    ...configComputed,
    theme() {
      return this.$store.state.theme;
    },
    fields() {
      return [
        { key: "#", class: "text-center align-middle p-3 tilte-column" },
        {
          key: "mobile",
          label: this.$t("menuitems.hospital.mobile"),
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "patient_id",
          label: '会員ID',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "age",
          formatter: val => (val && val) ? val + " 歳" : "",
          label: "年齢",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "sex",
          formatter: val => ["女性", "男性", "無回答"][val] ?? "無回答",
          label: "性別",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "is_plus",
          label: this.$t("menuitems.hospital.joined"),
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "facilities",
          label: this.$t("menuitems.user.facilities"),
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "created_at",
          label: this.$t("menuitems.user.facilities"),
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "updated_at",
          label: this.$t("menuitems.user.facilities"),
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "actions",
          label: "操作",
          class: "text-center align-middle p-3 tilte-column",
        },
      ];
    },
  },

  methods: {
    ...userMethods,
    ...configMethods,

    async handlerEditProfileUser(id) {
      try {
        this.showModalEditProfileUser = true;
        this.dataEdit = this.gUsers.find(item => item.id === id);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },

    async closeModal() {
      this.showModalEditProfileUser = false;
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },

    reloadPage() {
      window.location.reload();
    },

    listFacility() {
      api.getListNameFacility().then((e) => {
        if (e.status === 200) {
          this.facilityNames = e.data.map(facility => facility.name);
        }
      });
    },

    changeSelected() {
      document.onkeyup = (e) => {
        if (e.keyCode === 13) {
          this.onFilter();
        }
      };
    },

    isChecked(id) {
      return (
        (this.isAll && !this.ignoreIds.includes(id)) ||
        this.excelIds.includes(id)
      );
    },

    isCheckedAll() {
      if (this.gUsers.length > 0) {
        return (
          (this.isAll && this.ignoreIds.length === 0) ||
          this.excelIds.length === this.gPagination.total
        );
      }

      return false;
    },

    checkAll() {
      if (this.ignoreIds.length > 0) {
        this.ignoreIds = [];
      } else {
        this.isAll = !this.isAll;
        if (!this.isAll) {
          this.excelIds = [];
        }
      }
    },

    activeExport() {
      if (this.gUsers.length > 0) {
        return !this.isAll && this.excelIds.length === 0;
      }

      return true;
    },

    removeUser() {
      this.confirm(
        {
          title: "",
          text: "この会員を削除しますか?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
        },
        async (e) => {
          if (e.isConfirmed) {
            const res = await this.doAction("remove");
            if (res.status == 200) {
              window.toastr.success("削除に成功しました");
              await this.onSearch();
              this.getACountUser(this.role);
            } else {
              window.toastr.error("削除に失敗しました");
            }
          }
        }
      );
    },

    async doAction(type) {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("会員を選択してください");
      } else {
        try {
          let payload = {
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          };
          if (this.isAll) {
            if (this.search.age !== undefined && this.search.age !== "") {
              payload.age = this.search.age;
            }
            if (
              this.search.birthday !== undefined &&
              this.search.birthday !== ""
            ) {
              payload.birthday = filter.fomatDate(
                this.search.birthday,
                "YYYY/MM/DD"
              );
            }
            if (
              this.search.fullname !== undefined &&
              this.search.fullname !== ""
            ) {
              payload.fullname = this.search.fullname;
            }
            if (
              this.search.mobile !== undefined &&
              this.search.mobile !== ""
            ) {
              payload.mobile = this.search.mobile;
            }
            if (this.search.status !== undefined && this.search.status) {
              payload.status = this.search.status.value;
            }
            if (this.search.sex !== undefined && this.search.sex) {
              payload.sex = this.search.sex.value;
            }
            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
            }
            if (
              this.search.facility_name !== undefined &&
              this.search.facility_name !== ""
            ) {
              payload.facility_name = search.facility_name;
            }
            if (this.search.is_plus !== undefined && this.search.is_plus) {
              payload.is_plus = this.search.is_plus.value;
            }
          } else {
            payload.ids = this.excelIds.toString();
          }
          payload.role = this.role

          const response =
            type === "excel"
              ? api.exportExcelUser(payload)
              : api.deleteUsers(payload);
          this.initExport();

          return response;
        } catch (error) {
          console.log(error);
        }
      }
    },

    chooseItem(id) {
      if (this.isAll) {
        this.ignoreIds = this.setArray(this.ignoreIds, id);
        if (this.ignoreIds.length === this.gPagination.total) {
          this.isAll = false;
          this.excelIds = [];
        }
      } else {
        this.excelIds = this.setArray(this.excelIds, id);
        if (this.excelIds.length === this.gPagination.total) {
          this.isAll = true;
          this.ignoreIds = [];
        }
      }
    },

    setArray(array, id) {
      const index = array ? array.findIndex((element) => element === id) : -1;
      index >= 0 ? array.splice(index, 1) : array.push(id);

      return array;
    },

    async onSearch(page = 1) {
      try {
        if (this.search.age > 120) {
          window.toastr.error(
            "1から120までの整数を入力する必要があります。もう一度やり直してください"
          );
          return;
        }
        this.loading = true;
        this.page = page < 1 ? 1 : page;
        await this.fetch(
          Object.assign(this.search, {
            role: this.role,
            page: this.page,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          })
        ).then((e) => {
          if (e.status == 200) {
            this.loading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async onFilter() {
      this.getACountUser(this.role);
      this.initExport();
      await this.onSearch();
    },

    async onClear() {
      this.search = {};
      this.initExport();
      await this.onSearch();
    },

    initExport() {
      this.isAll = false;
      this.ignoreIds = [];
      this.excelIds = [];
    },

    onSort(key) {
      if (key === this.keySort) {
        this.typeSort = Math.abs(this.typeSort - 1);
      } else {
        this.keySort = key;
        this.typeSort = 0;
      }

      this.onSearch();
    },

    async pagination(page) {
      try {
        this.loading = true;
        await this.onSearch(page);
      } catch (error) {
        console.log(error);
      }
    },

    async handlerSubmit() {
      try {
        await this.post(this.dataInsert);
        this.alertSuccess();
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    checkDisabled() {
      const check =
        this.search.fullname ||
        this.search.mobile ||
        this.search.age ||
        this.search.sex ||
        this.search.birthday ||
        this.search.facility_name ||
        this.search.status;
      return !check;
    },

    isDisabled(...data) {
      console.log(data, "========>");
    },

    async handlerUpdate() {
      try {
        await this.update(this.dataUpdate);
        this.alertSuccess();
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    async handlerDelete(payload = {}) {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const respon = await this.del(payload.uuid);
            if (respon.status === 200) {
              this.alertSuccess();
              this.fetch();
            }
            if (respon.status !== 200) {
              this.alertError(respon.status);
              return;
            }
          }
        });
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    selectFilterGender(context) {
      this.search.sex = context.value;
    },

    async handlerApproved() {
      try {
        const respon = await this.approved();
        console.log(respon);
        this.alertSuccess();
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    async handlerReject() {
      try {
        const respon = await this.reject();
        console.log(respon);
        this.alertSuccess();
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    showModalEdit() { },
  },
};
</script>
<template>
  <div id="admin">
  <Layout class="kurua-page">
    <EditProfileUser lazy @closeModal="closeModal" :isShowEdit="showModalEditProfileUser" :data="dataEdit" :isPlus="true"/>
    <div class="col-12 d-flex justify-content-between align-items-center mb-xl-0 mt-lg-n3 mb-lg-2 mt-md-n3 mb-md-2">
      <div class="d-flex align-items-center justify-content-start mt-xl-2 mt-md-n4">
        <PageHeader :items="items" fontSize="28px" fontWeight="700 !important" margin-top="6px !important"/>
        <div class=" d-flex reload-button" style="margin-left: 8rem;">
          <button @click="reloadPage" class="custom-button">
            <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
            更新</button>
          <div>
            <p style="margin: 0; padding-left: 10px; font-size: 14px ;">最終更新日時</p>
            <p style="margin: 0; padding-left: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 pb-3">
        <div class="row">
          <div class="col-4">
            <b-button class="col-6 w-100 px-1"
              style="margin-left: 10px; background-color: white; border: 1px solid #395299; color: #395299 !important;"
              @click="toggleFilter()">
              <img src="@/assets/images/icon/icon-filter.svg" alt="" style="width: 20px; height: 20px;" />
              絞り込み
            </b-button>
          </div>
          <div class="col-4">
            <b-button :disabled="activeExport()" :class="{ 'bg-disabled': activeExport() }" class="btn-lyg col-6 w-100 px-0"
              style="margin-left: 10px;" @click="doAction('excel')">
              <img
                :src="!activeExport() ? require('@/assets/images/icon/icon-export-white.svg') : require('@/assets/images/icon/icon-export.svg')"
                alt="" style="width: 20px; height: 20px;" />
              Excel出力</b-button>
          </div>
          <div class="col-4">
            <b-button :disabled="activeExport()" :class="{ 'bg-disabled': activeExport() }"
              class="btn-danger col-6 w-100" @click="removeUser()">
              <img
                :src="!activeExport() ? require('@/assets/images/icon/icon-trash-white.svg') : require('@/assets/images/icon/icon-trash.svg')"
                alt="" style="width: 20px; height: 20px;" />
              削除</b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="isFilterOpen">
      <div class="col-12 p-4">
        <h5 class="text-label-filter">{{ $t("menuitems.hospital.filter") }}</h5>
        <hr />
        <form action="" @submit.prevent="onFilter">
          <div class="row">
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.mobile')" label-for="会員ID">
                <b-form-input v-model="search.mobile" :placeholder="$t('menuitems.hospital.placeholderMobile')"
                  for="会員ID" :maxlength="256" value="" class="helo" type="search"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.userId')" label-for="会員ID">
                <b-form-input v-model="search.patient_id" :placeholder="$t('menuitems.hospital.placeholderUserId')"
                  for="会員ID" :maxlength="256" value="" class="helo" type="search"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.age')" label-for="年齢">
                <b-form-input v-model="search.age" :formatter="(e) => {
                  if (e) {
                    if (e > 120) return 120;
                    if (e < 1) return 1;
                    return e;
                  }
                }
                  " :placeholder="$t('menuitems.hospital.placehoderAge')" for="年齢 xx" type="number">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.sex')" label-for="性別">
                <multiselect label="label" :show-labels="false" track-by="value" @input="changeSelected"
                  v-model.number="search.sex" :searchable="false" for="性別" type="search"
                  :options="gGetConfig.gender || []" placeholder="性別を選択してください。" class="helo text-table">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.user.membership')" label-for="">
                <multiselect label="label" :show-labels="false" track-by="value" @input="changeSelected"
                  v-model.number="search.is_plus" :searchable="false" type="search" :options="is_plus || []"
                  placeholder="会員区分を選択してください。" class="helo text-table">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.user.facilities')"
                label-for="facilities-search">
                <multiselect v-model="search.facility_name" :options="facilityNames || []" placeholder="所属施設を入力してください。"
                  id="code" class="helo" :multiple="false" :show-labels="false" style="z-index: 1040;">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4 text-white">
              <div class="row">
                <div class="col-6">
                  <b-form-group label="0000">
                    <b-button type="submit" class="btn-lyg-new w-100 pl-1 pr-1 text-button">
                      {{ $t("menuitems.hospital.search") }}
                    </b-button>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label="0000">
                    <button class="btn btn-outline-lyg-new w-100 text-button" @click="onClear()"> クリア </button>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="mb-0" :style="{ minHeight: isFilterOpen ? '50vh' : '80vh' }">
      <Loader :loading="loading" theme="plus">
        <div class="col-12">
          <b-table :items="gUsers || []" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            sort-icon-left hover outlined thead-class="sticky-top text-center" sticky-header
            :style="{ maxHeight: isFilterOpen ? '44vh' : '75vh' }" responsive="sm">
            <template #head()="{ label, field: { key, sortable } }">
              {{ label }}
              <template v-if="sortable">
                <template>
                  <span v-if="sortBy !== key">
                    <i class="mdi mdi-sort-bool-ascending"></i>
                  </span>
                  <span v-else-if="sortDesc">
                    <i class="mdi mdi-sort-bool-descending"></i>
                  </span>
                  <span v-else>
                    <i class="mdi mdi-sort"></i>
                  </span>
                </template>
              </template>
            </template>
            <template #head(#)>
              <b-form-checkbox id="checkbox-all" @change="checkAll()" name="checkbox-all" :checked="isCheckedAll()">
              </b-form-checkbox>
            </template>
            <template #cell(#)="row">
              <b-form-checkbox id="checkbox-1" @change="chooseItem(row.item.id)" name="checkbox-1"
                :checked="isChecked(row.item.id)"></b-form-checkbox>
            </template>
            <template #cell(mobile)="row">
              <a @click="$router.push(`/admin/users/${row.item.uuid}`)" class="text-link" style="cursor: pointer;">{{
                row.item.mobile }}</a>
            </template>

            <!-- cell patient_id -->
            <template #cell(patient_id)="row">
              {{ row.item.patient_id }}
            </template>

            <!-- cell age -->
            <template #head(age)="row">
              <div @click="onSort('information.age')">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'information.age'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'information.age'"></i>
                </span>
              </div>
            </template>
            <template #cell(age)="row">
              {{ row.item.information?.age || '' }}
            </template>

            <!-- cell sex -->
            <template #head(sex)="row">
              <div @click="onSort('information.sex')">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'information.sex'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'information.sex'"></i>
                </span>
              </div>
            </template>
            <template #cell(sex)="row">
              {{ ["女性", "男性", "無回答"][row.item?.information?.sex] ?? "無回答" }}
            </template>

            <!-- cell facilities -->
            <template #cell(facilities)="row">
              <div>
                {{ row.item.facilities && row.item.facilities.length > 0 ? row.item.facilities.map(facility =>
                  facility.name).join(', ') : 'なし' }}
              </div>
            </template>
            <template #cell(cellStatus)="row">
              <span class="badge rounded-pill font-size-11" :class="{
                'badge-soft-success': row.item.is_used === 1,
                'badge-soft-danger': row.item.is_used === 0,
                'badge-soft-info': row.item.is_used === 2,
              }">
                {{ row.item.is_used ? "稼働中" : "退会" }}
              </span>
              <div class="mt-1">
                <div v-if="row.item.action_date">
                  {{ row.item.action_date | fomatDate2 }}
                </div>
                <div v-else>{{ row.item.created_at | fomatDate2 }}</div>
              </div>
            </template>

            <!-- cell is_plus -->
            <template #head(is_plus)="row">
              <div @click="onSort('type')">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'type'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'type'"></i>
                </span>
              </div>
            </template>
            <template #cell(is_plus)="row">
              <div>
                <span v-if="!row.item?.facilities.length">
                  くるあ
                </span>
                <span v-else>
                  <span v-for="facility in row.item.facilities" :key="facility.id">
                    {{ facility.type === 2 ? "くるあプラス" : "くるあ" }}
                  </span>
                </span>
              </div>
            </template>
            <template slot="selected" slot-scope="data">
              <b-form-checkbox @click.native.stop :value="data.item.schoolId" :checked="allSelected"></b-form-checkbox>
              {{ data.index }}
            </template>

            <!-- cell created_at -->
            <template #head(created_at)="row">
              <div @click="onSort('created_at')">
                <span>登録日</span>
                <span v-if="keySort === 'created_at'">
                  <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                </span>
                <i class="mdi mdi-sort" v-if="keySort !== 'created_at'"></i>
              </div>
            </template>
            <template #cell(created_at)="row">
              {{ row.item.created_at | fomatDate2 }}
            </template>

            <!-- cell updated_at -->
            <template #head(updated_at)="row">
              <div @click="onSort('updated_at')">
                <span>最終更新日</span>
                <span v-if="keySort === 'updated_at'">
                  <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                </span>
                <i class="mdi mdi-sort" v-if="keySort !== 'updated_at'"></i>
              </div>
            </template>
            <template #cell(updated_at)="row">
              {{ row.item.updated_at | fomatDate2 }}
            </template>

            <!-- cell actions -->
            <template #cell(actions)="row">
              <ul class="list-inline font-size-20 contact-links mb-0">
                <li title="編集" @click=handlerEditProfileUser(row.item.id) :showEdit="true"
                  class="list-inline-item px-2 icon-large">
                  <a>
                    <img src="@/assets/images/icon/icon-changes.svg" alt="" style="width: 35px; height: 35px;" />
                  </a>
                </li>
              </ul>
            </template>

          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="gUsers.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>
        <Pagination :paging="gPagination" @change="pagination" label="会員数：" unitLabel="名" />
      </Loader>
    </div>
  </Layout>
  </div>
</template>

<style scoped>
::v-deep th {
  text-align: center !important;
}
.custom-button:hover {
  background-color: #395299;
}
</style>
